module.exports = __webpack_public_path__ + "static/media/sun.1c31400d.png";